export const manifest = {
  screens: {
    scr_073goc: { name: "Home", route: "/" },
  },
}
